export const PLAN = [
  { label: 'Starter', value: 'starter' },
  { label: 'Unlimited', value: 'unlimited' },
  { label: 'Corporate', value: 'corporate' },
]

export const TERM = [
  { label: 'Recurrent', value: 1 },
  { label: 'Non-recurrent', value: 0 },
]

export const REGEX_PASSPORT_PAY = /^\/client\/passport\/pay\/[^/]+\/[^/]+$/
